import type { IStringifyOptions } from "qs";

export const qsOptions: IStringifyOptions = {
  skipNulls: true,
  arrayFormat: "comma",
  filter: (_key, value) => {
    if (value === "" || (Array.isArray(value) && value.length === 0)) {
      return undefined;
    }
    return value;
  },
};
